module.exports = __webpack_public_path__ + "static/media/airblitz-2.e33e3ffb.jpg";